module.exports = __webpack_public_path__ + "img/about-m-slide-7.36ede680.jpg";